var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{style:({ 'max-width': _vm.invoice_options.logo.max_width + 'px', 'max-height': _vm.invoice_options.logo.max_height + 'px' }),attrs:{"src":_vm.invoice_options.logo.url}})
}
var staticRenderFns = []

export { render, staticRenderFns }